import type { RateTier } from '../../types/electricity'
import { useLanguage } from '../../i18n/LanguageContext'

export function PulsingDot({ tier }: { tier: RateTier }) {
  const { t } = useLanguage()
  const color = tier === 'peak' ? 'bg-red-500' : 'bg-emerald-400'

  return (
    <div className="flex items-center gap-2">
      <div className={`live-dot ${color}`} />
      <span className="text-xs text-slate-400 uppercase tracking-wider">{t('rate.live') as string}</span>
    </div>
  )
}
